import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import TitleHeader from 'components/presenters/header/TitleHeader';
import MatchingRoomForm from 'components/presenters/matching/room/MatchingRoomForm';
import server from 'server/serverController2';

export default function CreateMatchingRoomLayout() {

  const history = useHistory();

  const [valid, setValid] = useState(false);
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [capacity, setCapacity]  = useState(2);

  useEffect(()=>{
    validate();
  },[capacity, description, title]);

  const validate = ()=>{
    if([null, undefined].includes(title) || [null, undefined].includes(description) || 
      title.length === 0 || description.length === 0 || capacity < 2 || capacity > 10)
    {
      setValid(false);
      return;
    } 
    setValid(true);
  }

  const handleChange = (updatedField)=>{
    if(updatedField['title'] !== undefined) setTitle(updatedField['title']) ;
    if(updatedField['description'] !== undefined && updatedField['description'].length <= 150) setDescription(updatedField['description']) ;
    if(updatedField['capacity'] !== undefined && updatedField['capacity'] > 1 && updatedField['capacity'] < 11) setCapacity(updatedField['capacity']) ; 
  }
  const handleCreateRoom = (e)=>{
    const form = {};
    form['title'] = title;
    form['description'] = description;
    form['max_capacity'] = capacity;
    server.postRequestData('matching/rooms', form, (res)=>{
      if(res.success !== 1)
      {
        return;
      }
      history.replace('/matching');
    })
  } 

  return (
    <>
      <div style={{height: 'calc(100vw*(51/375))'}}>
        <TitleHeader onBackBtn={null} showComplete={true} isComplete={valid} onCompleteClick={handleCreateRoom} />
      </div>
      <div>
        <MatchingRoomForm onChange={handleChange} description={description} capacity={capacity} />
      </div>
    </>
  );
}
